import { Injectable } from '@angular/core';
import Hammer from 'hammerjs';

@Injectable({ providedIn: 'root' })
export class CustomGestureConfig {
  buildHammer(element: HTMLElement): HammerManager {
    return new Hammer(element, {
      touchAction: 'pan-y',
    });
  }
}
